<template>
    <div class="menu-item">
        <div id="menu-toggler" :class="'toggle ' + ((isOpen) ? 'toggled':'')"
            @click=" () => {
                test = !test;
                isOpen = !isOpen;
                open = false;
                
                this.changeWpmlColor();
                this.changeLogoBrightness();
                if (isOpen) {
                    this.disableScrolling();
                }
                this.hideBackToTop(isOpen);
            }">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <transition
        name="scaleDown"
        appear
        @enter="onEnter"
        @after-enter="afterEnter"
        @before-leave="onBeforeLeave"
        @leave="onLeave"
        @after-leave="onAfterLeave"
        >
            <div class="mainside" v-if="isOpen && secondTime">
                <div class="menu-container">
                    <div class="flex-col1">
                        <!-- <div class="menu-col">
                            <div class="menu-item el">
                                <div class="menu-row">
                                    <a href="tel:+302110159340">
                                       <i class="fa fa-phone lg"></i>
                                        211 015 9340
                                    </a>
                                </div>
                            </div>
                            <div class="menu-item el">
                                <div class="menu-row">
                                    <a href="mailto:info@anvetogroup.com">
                                        <i class="fa fa-envelope lg"></i>
                                        Στείλτε μας Email
                                    </a>
                                </div>
                            </div>
                            <div class="menu-item el">
                                <div class="menu-row">
                                    <a href="/contact">
                                        <i class="fa fa-comment lg"></i>
                                        Επικοινωνήστε μαζί μας
                                    </a>
                                </div>
                            </div>
                            <div class="menu-item eng">
                                <div class="menu-row">
                                    <a href="tel:+302110159340">
                                       <i class="fa fa-phone lg"></i>
                                        211 015 9340
                                    </a>
                                </div>
                            </div>
                            <div class="menu-item eng">
                                <div class="menu-row">
                                    <a href="mailto:info@anvetogroup.com">
                                        <i class="fa fa-envelope lg"></i>
                                        Send us an Email
                                    </a>
                                </div>
                            </div>
                            <div class="menu-item eng">
                                <div class="menu-row">
                                    <a href="/contact">
                                        <i class="fa fa-comment lg"></i>
                                        Contact us
                                    </a>
                                </div>
                            </div>
                        </div> -->
                        <div class="menu-col">
                                                   
                                        <!--<div class="menu-row " v-if="i==0">
                                            <a class="istoselides" id="first-c" @mouseover="()=>{openfirst= false ,openp = false; openc = true, openco=false, openy = false; openpr = false, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row " v-if="i==1 && test">
                                            <a class="eshop" id="sec-c" @mouseover="()=>{openfirst= false, openp = true; openc = false, openco=false, openy = false; openpr = false, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row" v-if="i==2 && test">
                                            <a class="epikinonia" id="third-c" @mouseover="()=>{openfirst= false, openp = false; openc = false, openco=false,openy = false; openpr = false, opene=true}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row" v-if="i==3 && test">
                                            <a class="epikinonia" id="fourth-c" @mouseover="()=>{openfirst= false, openp = false; openc = false, openco=false,openy = false; openpr = true, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row" v-if="i==4 && test">
                                            <a class="epikinonia" id="fourth-c" @mouseover="()=>{openfirst= false, openp = false; openc = false, openco=false,openy = false; openpr = true, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row" v-if="i==5 && test">
                                            <a class="epikinonia" id="fourth-c" @mouseover="()=>{openfirst= false, openp = false; openc = false, openco=false,openy = false; openpr = true, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>-->
                                   
                                        <div class="menu-row">
                                            <a class="epikinonia" id="fourth-c" href="/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Αρχική</a>
                                        </div>
                                        <div class="menu-row">
                                            <a class="epikinonia" id="fourth-c" href="/xenodoxio/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ξενοδοχείο</a>
                                        </div>
                                        <div class="menu-row">
                                            <a class="epikinonia" id="fourth-c" href="/topothesia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Τοποθεσία</a>
                                        </div>
                                        <div class="menu-row">
                                            <a class="epikinonia" id="fourth-c" href="/contact-us/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Επικοινωνία</a>
                                        </div>
                                        
                                    
                            
                        </div>
                        <div class="menu-col">
                            <!--<div v-for="(item,i) in items.slice(0, 6)" :key="i" class="menu-item el">                            
                                        <div class="menu-row " v-if="i==6">
                                            <a class="istoselides" id="first-c" @mouseover="()=>{openfirst= false ,openp = false; openc = true, openco=false, openy = false; openpr = false, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row " v-if="i==7 && test">
                                            <a class="eshop" id="sec-c" @mouseover="()=>{openfirst= false, openp = true; openc = false, openco=false, openy = false; openpr = false, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row" v-if="i==8 && test">
                                            <a class="epikinonia" id="third-c" @mouseover="()=>{openfirst= false, openp = false; openc = false, openco=false,openy = false; openpr = false, opene=true}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row" v-if="i==9 && test">
                                            <a class="epikinonia" id="fourth-c" @mouseover="()=>{openfirst= false, openp = false; openc = false, openco=false,openy = false; openpr = true, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row" v-if="i==10 && test">
                                            <a class="epikinonia" id="fourth-c" @mouseover="()=>{openfirst= false, openp = false; openc = false, openco=false,openy = false; openpr = true, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                        <div class="menu-row" v-if="i==11 && test">
                                            <a class="epikinonia" id="fourth-c" @mouseover="()=>{openfirst= false, openp = false; openc = false, openco=false,openy = false; openpr = true, opene=false}" :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                                        </div>
                                </div>-->
                                        <div class="menu-row">
                                            <a class="epikinonia" id="fourth-c" href="/domatia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Δωμάτια</a>
                                        </div>
                                        <div class="menu-row">
                                            <a class="epikinonia" id="fourth-c" href="/mple-souita-me-thea-sti-thalassa/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Μπλε Σουίτα</a>
                                        </div>
                                        <div class="menu-row">
                                            <a class="epikinonia" id="fourth-c" href="/roz-souita/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ροζ Σουίτα</a>
                                        </div>
                                        <div class="menu-row">
                                            <a class="epikinonia" id="fourth-c" href="/diklino-domatio-me-mpalkoni/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Δίκλινο Δωμάτιο</a>
                                        </div>                           
                        </div>
                        
                    </div>
                    <hr class="menu-divider" />
                    <div class="menu-contact-details">
                        <div class="menu-item el">
                            <div class="menu-row">
                                <a href="tel:+302110159340">
                                    <i class="fa fa-phone"></i>
                                    <span>
                                        211 015 9340
                                    </span> 
                                </a>
                            </div>
                        </div>
                        <div class="menu-item el">
                            <div class="menu-row">
                                <a href="mailto:info@anvetogroup.com">
                                    <i class="fa fa-envelope lg"></i>
                                    <span>
                                        Στείλτε μας Email
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="menu-item el">
                            <div class="menu-row">
                                <a href="/contact">
                                    <i class="fa fa-comment lg"></i>
                                    <span>
                                        Επικοινωνήστε μαζί μας
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="menu-item eng">
                            <div class="menu-row">
                                <a href="tel:+302110159340">
                                    <i class="fa fa-phone"></i>
                                    <span>
                                        211 015 9340
                                    </span> 
                                </a>
                            </div>
                        </div>
                        <div class="menu-item eng">
                            <div class="menu-row">
                                <a href="mailto:info@anvetogroup.com">
                                    <i class="fa fa-envelope lg"></i>
                                    <span>
                                        Send us an Email
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="menu-item eng">
                            <div class="menu-row">
                                <a href="/contact">
                                    <i class="fa fa-comment lg"></i>
                                    <span>
                                        Contact Us
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- SIDE MENU -->
<!--         
        <transition name="fade" appear>
                <div class="side-flex" v-if="openc && isOpen">
                    <div class="column1">
                    </div>
                </div>
        </transition>
        <transition name="fade" appear>
            <div class="side-flex" v-if="openp && isOpen">
                <div class="column2">
                </div>
            </div>
            
        </transition>
        <transition name="fade" appear>
            <div class="side-flex" v-if="openco && isOpen">
                <div class="column3">
                </div>
            </div>
        </transition>
          <transition name="fade" appear>
            <div class="side-flex" v-if="openy && isOpen">
                <div class="column4">
                </div>
            </div>
        </transition>
          <transition name="fade" appear>
            <div class="side-flex" v-if="openpr && isOpen">
                <div class="column5">
                </div>
            </div>
        </transition>
          <transition name="fade" appear>
            <div class="side-flex" v-if="opene && isOpen">
                <div class="column6">
                </div>
            </div>
        </transition> -->
    </div>
</template>

<script>

export default ({
    name: 'main-menu',
    props: ['title', 'items'],
    data () {
        return{
            test: false,
            isOpen: false,
            secondTime: true,
            openc: false,
            openp: false,
            openco: false,
            openy:false,
            openpr:false,
            opene:false,
            openfirst: true,
            open: ['openc','openp','openco','openy','openpr','opene'],
        }
    },
    methods: {
        changeWpmlColor: function () {
            // change language selection border color
            this.changeRootVariable('--wpml-col', this.isOpen, '#AC9121', '#fff');
        },
        changeLogoBrightness: function () {
            // change logo brightness when menu opens
            this.changeRootVariable('--logo-brightness', this.isOpen, '10%', '100%');
        },
        changeRootVariable: function (variable, condition, valueA, valueB) {
            const root = document.querySelector(':root');
            const newValue = (condition) ? valueA : valueB;
            root.style.setProperty(variable, newValue);
        },
        onEnter: function () {
            console.log('this is on enter');
            const menuRows = document.getElementsByClassName('menu-row');
            for (let row of menuRows) {
                row.onanimationend = (event) => {
                    if (event.animationName === 'slideUpwards') {
                        /*row.style.transform = 'translate(0px)';*/
                    }
                    else if (event.animationName == 'slideDownwards') {
                        /*row.style.transform = 'translate(100px)';*/
                    }
                };
            }
        },
        afterEnter: function () {
            console.log('this runs after the enter animation has ended');
            const menuRows = document.getElementsByClassName('menu-row');
            for (let row of menuRows) {
                row.classList.toggle('slideUp');
            }
        },
        onBeforeLeave: function () {
            console.log('this runs before the element leaves the DOM.');
            const menuRows = document.getElementsByClassName('menu-row');
            for (let row of menuRows) {
                row.classList.toggle('slideUp');
            }
        },
        onLeave: function () {
            console.log('this runs before the element leaves the DOM.');
            const menuRows = document.getElementsByClassName('menu-row');
            for (let row of menuRows) {
                row.classList.toggle('slideDown');
            }
        },
        onAfterLeave: function () {
            // re-enable scrolling after animation has ended
            this.disableScrolling();
        },
        disableScrolling: function () {
            document.body.classList.toggle('disable-vertical-scroll');
        },
        hideBackToTop: function (isOpen) {
            const elem = document.getElementsByClassName('generate-back-to-top')[0];
            if (elem !== undefined) {
                elem.style.opacity = (isOpen) ? 0:1;
            }
        },
    }
})

</script>

<style>
    .products{
        padding-top:10px;
        padding-left: 20px;
        text-align: left;
        color:rgb(46, 46, 46);
    }
    .eng{
        display: none !important;
    }
    /* new */
    .mainside .close{
        display: flex !important;
        background: transparent !important;
        border-bottom: 0px !important;
        color:#000 !important;
        padding-top: 10px;
        justify-content: flex-start;
    }
    .mainside .close .close-icon{
        width: 40px;
        height: 40px;
        position: absolute;
        top:20px;
        right:20px;
        background: rgb(222 207 188);
        display: flex;
        justify-content: center;
        border-radius: 20px;
    }
    .mainside .close .close-icon:hover{
        background: rgb(46, 46, 46);
    }
    .mainside .close .close-icon:hover svg{
        filter: invert(100%) sepia(0%) saturate(7497%) hue-rotate(329deg) brightness(102%) contrast(101%) !important;
    }
    .mainside .close svg{
        filter: none !important;
        margin-left: 0px !important;
        margin-right: 0px !important;
    }

    /* */
    .mainside .flex {
        display: flex; 
    }
    .side-flex{
        background-color: #fff;
        width:150px !important;
        height: 100% !important;
        position: fixed;
        top:0px;
        left:400px;
        z-index: 99;
        box-shadow: 4px 6px 12px rgb(0 0 0 / 21%);
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        display: flex;
    }
    .side-flex .column1, .side-flex .column2, .side-flex .column3{
        width: 100% !important;
        border-top-right-radius:10px;
        border-bottom-right-radius: 10px;
    }
    .side-flex .column1{
        background: url('/wp-content/uploads/2022/08/depositphotos_322405710-stock-photo-front-view-devices-best-web.jpg');
    }
    .side-flex .column2{
        background: url('https://anveto.anvetogroup.com/wp-content/uploads/2022/08/4654890-scaled.jpg');
    }
    .side-flex .column3{
        background: url('/wp-content/uploads/2022/08/depositphotos_313343120-stock-illustration-evaluation-and-feedback-in-business.jpg');
    }
    .side-flex .column4{
        background: url('/wp-content/uploads/2022/08/kataskevi-istoselidas.png');
    }
    .side-flex .column5{
        background: url('/wp-content/uploads/2022/08/hero.webp');
    }
    .side-flex .column6{
        background: url('/wp-content/uploads/2022/08/hero2.png');
    }
    nav .menu-item svg{
        width:10px;
        filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(262deg) brightness(100%) contrast(103%);
    }
    .button-menu{
        background: #686fcf;
        border-radius: 10px;
        padding:10px 20px;
        margin:10px 20px;
    }
    .button-menu:hover{
        background-color:#2b3185;
    }
    .menu-btn{
        padding-left:10px !important;
    }
    .menu-btn svg{
        margin-right: 10px;
    }
    nav .menu-item .mainside{
        background-color: #e9e5e0;
        width:400px !important;
        height: 100% !important;
        position: fixed;
        top:0px;
        left:0px;
        z-index: 99;
        box-shadow: -5px 4px 12px rgb(0 0 0 / 21%);
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        padding:20px;
    }
    .close{
        background-color: #858ce1;
        padding:20px;
        display: flex;
        margin-bottom: 20px;
        border-bottom:1px solid #fff;
        justify-content: center;
    }
    .close svg{
        transform: scale(1.5);
        margin-right: 20px;
        margin-left: 10px;
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(203deg) brightness(104%) contrast(103%) !important;
    }
    .close h4{
        color:#fff;
        margin-bottom:0px !important;
		font-family:play !important;
		font-size:20px !important;
    }
    .mainside .menu-item {
        background-color:#e9e5e0;
        color:#686fcf;
        font-size: 20px;
        padding: 5px 20px;
        font-weight: 600;
        border-radius: 10px;
    }
    .mainside .menu-item a{
       width: 100%;
       text-align: left;
       padding: 10px 0px;
       cursor:pointer;
       transition: none !important;
       
    }
    
    .mainside .menu-item a:hover{
        border-radius: 10px;
    }
    
    .mainside .menu-item a{
       text-align: left;
       text-decoration: none;
       color:#000;
       display: inline-block;
       padding-bottom:5px;
       position: relative;
       width: auto !important;
    }

     .mainside .menu-item a:after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #000;
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }

    .mainside .menu-item a:hover:after{
        transform: scaleX(1);
        transform-origin: bottom left;
    }

    .side-flex  .menu-item {
        color:#686fcf;
        font-size: 20px;
        padding: 5px 20px;
        font-weight: 600;
        border-radius: 10px;
    }
    .side-flex .menu-item a{
       width: 100%;
       text-align: left;
       padding: 10px 20px;
       text-align: center;
    }  

    
    .side-flex .menu-item a:hover{
        background: #686fcf;
        border-radius: 10px;
        color:#fff;
    }
    .flex-col3 .menu-item a{
       width: 100%;
       text-align: left;
       padding: 10px 20px;
       text-align: center;
    }  

    
    .flex-col3 .menu-item a:hover{
        background: #686fcf;
        border-radius: 10px;
        color:#fff;
    }
    .fade1-enter-active{
        transition: all 0.5s ease-out;
    }

    .fade1-enter{
        opacity: 0;
    }


@media only screen and (max-width: 991px) {
    .flex-col2{
    display: none !important;
   }
    .mainmenu .close{
        display: flex !important;
    }
    nav .menu-item .mainmenu{
            width: 100% !important;
            height: 100% !important;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            padding:0 !important;
        }
}
</style>